<template>
  <div>
    <afterorder-list v-show="tabType === 1" @handleShow="handleShow" />
    <afterorder-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow"  />
  </div>
</template>

<script>
import afterorderList from './list.vue'
import afterorderShow from './show.vue'
export default {
  components: { afterorderList, afterorderShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>